import { normalizeMaterialSummaryJsonField } from './normalize-material-summary-json-field.util';

/**
 * One Excel cell for UOM: `Symbol` when the value is an object; otherwise a legacy plain string (e.g. `"kg"`).
 */
export function formatMaterialSummaryUomForCell(value: unknown): string {
    const normalized = normalizeMaterialSummaryJsonField(value);
    if (normalized === undefined) {
        return '';
    }
    if (typeof normalized === 'string') {
        return normalized;
    }
    if (typeof normalized !== 'object' || normalized === null || Array.isArray(normalized)) {
        return '';
    }
    const o: Record<string, unknown> = normalized;
    const sym = o['Symbol'];
    if (typeof sym === 'string') {
        return sym.trim();
    }
    return '';
}
